import { render, staticRenderFns } from "./DetailPriceAwayWhite.vue?vue&type=template&id=0def80bc&scoped=true"
import script from "./DetailPriceAwayWhite.vue?vue&type=script&lang=js"
export * from "./DetailPriceAwayWhite.vue?vue&type=script&lang=js"
import style0 from "./DetailPriceAwayWhite.vue?vue&type=style&index=0&id=0def80bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0def80bc",
  null
  
)

export default component.exports